import { ReactNode, useRef } from 'react'
import * as React from 'react'
import styled from '@emotion/styled'
import { colors, fontFamilies } from '@configs/styles/config'

type Props = {
  active?: boolean
  index: number
  onClick: Function
  prevButton: number
  children: ReactNode
  avgWidth?: number[]
  current?: number
}

const GroupButtonContainer = styled.div<{ active: boolean }>`
  opacity: ${(props) => (props.active ? '1' : '0.6')};
  background-color: none;
  border: ${(props) =>
    props.active
      ? '1px solid ' + colors.uguDarkGrey
      : '1px solid rgb(0,0,0,0)'};
  cursor: pointer;
  white-space: nowrap;
  color: ${colors.uguPurple};
  height: 2rem;
  padding: 0px 12px;
  transition: all 0.1s ease-in-out;
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: ${fontFamilies.regular};
  letter-spacing: 0rem;
  :hover {
    opacity: 0.9;
  }
  @media (max-width: 640px) {
    font-size: 15px;
  }
`
const GroupButtonContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`

const GroupButton: React.FunctionComponent<Props> = (props) => {
  const buttonRef = useRef<HTMLDivElement>(null)
  const { active = false, onClick, children } = props

  return (
    <GroupButtonContainerWrapper className="md:snap-start">
      <GroupButtonContainer
        active={active}
        onClick={() => onClick()}
        ref={buttonRef}
      >
        {children}
      </GroupButtonContainer>
    </GroupButtonContainerWrapper>
  )
}

export default GroupButton
